module.exports = __webpack_public_path__ + "img/f9215686-be33-4a6e-bf6a-0c1bf8e402b1.738e4b37.png";